let itemsData = [
  {
  "sku_id": 100027101,
  "title": "坚果 Pro 软胶保护套",
  "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
  "ali_image": "http://image.smartisanos.cn/resource/902befd5f32a8caf4ca79b55d39ee25a.jpg",
  "price": 49,
  "limit_num": 5,
  "spec_json": {
    "image": "red",
    "show_name": "红色"
  },
  "ali_images": [
    "http://image.smartisanos.cn/resource/902befd5f32a8caf4ca79b55d39ee25a.jpg",
    "http://image.smartisanos.cn/resource/ca760e50409c796a4e770c54554f92bf.jpg",
    "http://image.smartisanos.cn/resource/493c65d42fe83ec3daaf058d79fc1a95.jpg",
    "http://image.smartisanos.cn/resource/0bf30081dd17431c4fdfbd237c53743f.jpg",
    "http://image.smartisanos.cn/resource/cba7b4cdb2fc41d7f29fb45d94972e41.jpg"
  ],
  "sku_list": [{
    "id": 100027101,
    "image": "red",
    "limit_num": 5,
    "color": "红色"
  },{
    "id": 100027102,
    "image": "black",
    "limit_num": 5,
    "color": "黑色"
  },{
    "id": 100027103,
    "image": "chocolate",
    "limit_num": 5,
    "color": "巧克力色"
  },{
    "id": 100027104,
    "image": "lightGold",
    "limit_num": 5,
    "color": "浅金色"
  }]
},{
  "sku_id": 100027102,
  "title": "坚果 Pro 软胶保护套",
  "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
  "ali_image": "http://image.smartisanos.cn/resource/554da94d8e4f84f03e0015fd1c997f46.jpg",
  "price": 49,
  "limit_num": 5,
  "spec_json": {
    "image": "black",
    "show_name": "黑色"
  },
  "ali_images": [
    "http://image.smartisanos.cn/resource/554da94d8e4f84f03e0015fd1c997f46.jpg",
    "http://image.smartisanos.cn/resource/01f25111e1a2c238a0f77e84aebd0796.jpg",
    "http://image.smartisanos.cn/resource/2841709c21ef07616f621fd863dcf2f3.jpg",
    "http://image.smartisanos.cn/resource/1b6fd01e415c380947cd98f62fa44817.jpg",
    "http://image.smartisanos.cn/resource/9e40a858dff00faa2f139587b7085249.jpg"
  ],
  "sku_list": [{
    "id": 100027101,
    "image": "red",
    "limit_num": 5,
    "color": "红色"
  },{
    "id": 100027102,
    "image": "black",
    "limit_num": 5,
    "color": "黑色"
  },{
    "id": 100027103,
    "image": "chocolate",
    "limit_num": 5,
    "color": "巧克力色"
  },{
    "id": 100027104,
    "image": "lightGold",
    "limit_num": 5,
    "color": "浅金色"
  }]
},{
  "sku_id": 100027103,
  "title": "坚果 Pro 软胶保护套",
  "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
  "ali_image": "http://image.smartisanos.cn/resource/84b58718b8f8da3c08e0931e19fdc62e.png",
  "price": 49,
  "limit_num": 5,
  "spec_json": {
    "image": "chocolate",
    "show_name": "巧克力色"
  },
  "ali_images": [
    "http://image.smartisanos.cn/resource/6d39130f5ad4bfe1241c0c17211472c2.jpg",
    "http://image.smartisanos.cn/resource/5694eb55ad2777a87096677d9d39cc58.jpg",
    "http://image.smartisanos.cn/resource/bffbb5411470d97a13f2f380006c96e4.jpg",
    "http://image.smartisanos.cn/resource/701052c09e45bd4069d3f8280d0d1435.jpg",
    "http://image.smartisanos.cn/resource/4fa7c5f81b02f71be4cae051ce547433.jpg"
  ],
  "sku_list": [{
    "id": 100027101,
    "image": "red",
    "limit_num": 5,
    "color": "红色"
  },{
    "id": 100027102,
    "image": "black",
    "limit_num": 5,
    "color": "黑色"
  },{
    "id": 100027103,
    "image": "chocolate",
    "limit_num": 5,
    "color": "巧克力色"
  },{
    "id": 100027104,
    "image": "lightGold",
    "limit_num": 5,
    "color": "浅金色"
  }]
},{
  "sku_id": 100027104,
  "title": "坚果 Pro 软胶保护套",
  "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
  "ali_image": "http://image.smartisanos.cn/resource/b20055215ae3db0f2c8b7ba4db68866f.png",
  "price": 49,
  "limit_num": 5,
  "spec_json": {
    "image": "lightGold",
    "show_name": "浅金色"
  },
  "ali_images": [
    "http://image.smartisanos.cn/resource/46d4b1cc072c7daa0c69756ac62ab46e.jpg",
    "http://image.smartisanos.cn/resource/e0d86a84c13b995fe87910324b3c7771.jpg",
    "http://image.smartisanos.cn/resource/1febef151c00c073d65eb37f68b75faf.jpg",
    "http://image.smartisanos.cn/resource/520666f8a84d92963320cf94bd74c05c.jpg",
    "http://image.smartisanos.cn/resource/7087d8239dec31662978c4c44c8501ba.jpg"
  ],
  "sku_list": [{
    "id": 100027101,
    "image": "red",
    "limit_num": 5,
    "color": "红色"
  },{
    "id": 100027102,
    "image": "black",
    "limit_num": 5,
    "color": "黑色"
  },{
    "id": 100027103,
    "image": "chocolate",
    "limit_num": 5,
    "color": "巧克力色"
  },{
    "id": 100027104,
    "image": "lightGold",
    "limit_num": 5,
    "color": "浅金色"
  }]
},{
  "sku_id": 100029901,
  "title": "Smartisan 快充移动电源 10000mAh",
  "sub_title": "10000mAh 双向快充、轻盈便携、高标准安全保护",
  "ali_image": "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
  "price": 199,
  "limit_num": 2,
  "spec_json": {
    "image": "gray",
    "show_name": "灰色"
  },
  "ali_images": [
    "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
    "http://image.smartisanos.cn/resource/0540778097a009364f2dcbb8c5286451.jpg",
    "http://image.smartisanos.cn/resource/ed7ea75824124d7385c99d532f1d4f1d.jpg",
    "http://image.smartisanos.cn/resource/40b8c1b1e5d175cc8fa9e7ff96cb6016.jpg",
    "http://image.smartisanos.cn/resource/fb24dc3db26c6f02542e0dea9b10151b.jpg"
  ],
  "sku_list": [{
    "id": 100029901,
    "image": "gray",
    "limit_num":2,
    "color": "灰色",
  }]
}]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/newItemsData.js